import { useCallback, useMemo } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useCurrentUserLazyQuery } from 'api/generated/graphql';
import { useError } from 'api/helpers';

import { parseEntity } from './parseEntity';

export const useCurrentUserLazy = () => {
  const [getCurrentUser, { data, loading, error: apolloError }] =
    useCurrentUserLazyQuery({
      notifyOnNetworkStatusChange: true,
    });

  const error = useError(apolloError);

  const user = useMemo(
    () =>
      data?.AuthController_getCurrentUser
        ? parseEntity(data.AuthController_getCurrentUser)
        : null,
    [data?.AuthController_getCurrentUser]
  );

  return {
    getCurrentUser: useCallback(async () => {
      const res = await getCurrentUser();
      return res.data?.AuthController_getCurrentUser
        ? parseEntity(res.data?.AuthController_getCurrentUser)
        : undefined;
    }, [getCurrentUser]),
    user,
    loading,
    error,
  };
};
